import { useEffect } from 'react'

import JsonToQuery from 'Utils/JsonToQuery'

import usePurchases from './UsePurchases'

function useSubscriptionPurchases({ query, page }) {
  const currentPage = page || 1
  const queryParams = {
    type: 'subscription',
    page: currentPage,
  }

  if (query) {
    queryParams.query = query
  }

  const initialUrl = `/api/internal/profile/purchases?${JsonToQuery(queryParams)}`

  const [{ data, isLoading, isError }, setUrl] = usePurchases({ initialUrl })

  useEffect(() => {
    setUrl(`/api/internal/profile/purchases?${JsonToQuery(queryParams)}`)
  }, [query, currentPage, setUrl])

  return { data, isLoading, isError }
}

export default useSubscriptionPurchases
